import { getCurrencySign } from '@v4/common/utils/currency';

/**
 * Convert number to formatted string.
 *
 * @param {numberToBeFormatted} number number to format
 * @param {decimals} number number of decimals to show
 * @param {decimalSeparator} string character to use as decimals spearator
 * @param {thousandSeparator} string character to use as thousands separator
 */
export const format = (numberToBeFormatted, decimals = 0, decimalSeparator = '.', thousandSeparator = ',') => {
    if (typeof numberToBeFormatted !== 'number') {
        return '';
    }

    const number = Number(numberToBeFormatted).toFixed(~~decimals);
    const parts = number.split('.');
    const decimalPart = parts[1] ? `${String(decimalSeparator)}${parts[1]}` : '';

    return parts[0].replace(/(\d)(?=(?:\d{3})+$)/g, `$1${String(thousandSeparator)}`) + decimalPart;
};

export const formatNumber = (numberToBeFormatted, locale) => {
    const decimalSeparator = locale === 'en' ? '.' : ',';
    const thousandSeparator = locale === 'en' ? ',' : '.';
    return format(numberToBeFormatted, 0, decimalSeparator, thousandSeparator);
};

export const formatCurrency = (price, locale) => `${getCurrencySign(locale)} ${formatNumber(price, locale)}`;
